import {Injectable} from '@angular/core';
import {AbstractSelectionService} from './abstract-selection.service';
import {EntityHydrator} from '../../../../../../services/entity-hydrator.service';

@Injectable()
export class GenericTreeGridSelectionService extends AbstractSelectionService {

  public constructor(
    protected entityHydrator: EntityHydrator
  ) {
    super(entityHydrator);
  }

  protected doOnSelectionInit(): void {

  }

  protected doSelect(entity: any, node?: TreeNode) {
    if (!this.component.selectedEntities.find((element) => {return element.id === entity.id; })){
      this.component.selectedEntities.push(entity);
    }

    if (!this.component.selectedNodes.find((aNode: TreeNode) => {return aNode.data.id === entity.id; })){
      this.component.selectedNodes.push(node);
    }
  }

  protected doUnSelect(entity: any, node?: TreeNode) {
    this.component.selectedEntities = this.component.selectedEntities.filter((element) => {return element.id !== entity.id; });
    this.component.selectedNodes = this.component.selectedNodes.filter((aNode: TreeNode) => {return aNode.data.id !== entity.id; });
  }

  protected doIsSelected(entity): boolean {
    return !!this.component.selectedEntities.find((element) => {
      return element.id === entity.id;
    });
  }
}
